import { Coins } from "lucide-react";
import { formatCurrencyEUR } from "@/lib/utils";

// I2: read-only rewards/earnings widget. The partner program is sold on
// commission ("rewards from €200 per successful referral"), so the portal
// surfaces reward status even before full payout tracking exists. Values are
// populated by the partnerships team (or a HubSpot sync); null = no data yet,
// in which case we show an encouraging "appears here" state rather than €0.
export function RewardsWidget({
  pendingEur,
  paidEur,
}: {
  pendingEur: number | null;
  paidEur: number | null;
}) {
  const hasData = pendingEur != null || paidEur != null;

  return (
    <section className="rounded-xl border bg-card p-6">
      <div className="flex items-center gap-2">
        <Coins className="h-4 w-4 text-accent" />
        <h2 className="font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">
          Your rewards
        </h2>
      </div>

      {hasData ? (
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-muted-foreground">Pending</p>
            <p className="mt-1 font-display text-2xl font-semibold tracking-tight tabular-nums">
              {formatCurrencyEUR(pendingEur ?? 0)}
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Paid out</p>
            <p className="mt-1 font-display text-2xl font-semibold tracking-tight tabular-nums">
              {formatCurrencyEUR(paidEur ?? 0)}
            </p>
          </div>
        </div>
      ) : (
        <p className="mt-4 rounded-md border border-dashed bg-muted/30 px-4 py-3 text-sm text-muted-foreground">
          Your referral rewards will appear here as deals close — partners earn
          from €200 per successful referral. The partnerships team confirms
          payouts.
        </p>
      )}

      <p className="mt-3 text-[11px] text-muted-foreground">
        Reward figures are confirmed by the Bookboost partnerships team.
      </p>
    </section>
  );
}
